import store from '@/state/store'

export default [
   {
      path: '/',
      name: 'home',
      meta: {
         authRequired: true,
      },
      component: () => import('./views/dashboards/default'),
   },

   {
      path: '/dashboard',
      name: 'dashboard',
      meta: {
         authRequired: true,
      },
      component: () => import('./views/dashboards/default'),
   },
   {
      path: '/login',
      name: 'login',
      component: () => import('./views/account/login'),
      meta: {
         beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
               // Redirect to the home page instead
               next({ name: 'default' })
            } else {
               // Continue to the login page
               next()
            }
         },
      },
   },

   {
      path: '/logout',
      name: 'logout',
      meta: {
         authRequired: true,
         beforeResolve(routeTo, routeFrom, next) {
            if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
               store.dispatch('auth/logOut')
            } else {
               store.dispatch('authfack/logout')
            }
            const authRequiredOnPreviousRoute = routeFrom.matched.some(
               (route) => route.push('/login')
            )
            // Navigate back to previous page, or home as a fallback
            next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
         },
      },
   },
   {
      path: '/404',
      name: '404',
      component: require('./views/utility/404').default,
   },
   // Redirect any unmatched routes to the 404 page. This may
   // require some server configuration to work in production:
   // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
   {
      path: '*',
      redirect: '404',
   },



   {
      path: '/counters',
      name: 'counters',
      meta: { authRequired: true },
      component: () => import('./views/counters/counters')
   },

   {
      path: '/outsource-token-calls',
      name: 'outsource-token-calls',
      meta: { authRequired: true },
      component: () => import('./views/outsource-token-calls/outsource-token-calls')
   },

   {
      path: '/tvs',
      name: 'tvs',
      meta: { authRequired: true },
      component: () => import('./views/tvs/tvs')
   },

   {
      path: '/tvshows',
      name: 'tvshows',
      meta: {
         authRequired: true,
      },
      component: () => import('./views/tvshows/tvshows')
   },

   {
      path: '/bookings',
      name: 'bookings',
      meta: { authRequired: true },
      component: () => import('./views/bookings/bookings')
   },


   {
      path: '/profile',
      name: 'profile',
      meta: { authRequired: true },
      component: () => import('./views/profile/profile')
   },


]
